// authed background
export const homeUrl = (): string => '/home'
export const virtualCardsUrl = (): string => '/virtualcards'
export const virtualCardsAllCardsUrl = (): string =>
  `${virtualCardsUrl()}/allcards`
export const virtualCardsYourCardsUrl = (): string =>
  `${virtualCardsUrl()}/yourcards`
export const virtualCardsRequestsUrl = (): string =>
  `${virtualCardsUrl()}/requests`
export const virtualCardsNeedsApprovalUrl = (): string =>
  `${virtualCardsUrl()}/needsapproval`
export const yourCardsUrl = (): string => '/virtualcards'
export const yourCardsActiveUrl = (): string => `${yourCardsUrl()}/active`
export const yourCardsInactiveUrl = (): string => `${yourCardsUrl()}/inactive`

export const myWalletUrl = (): string => '/mywallet'
export const myWalletVirtualCardsUrl = (): string =>
  `${myWalletUrl()}/virtualcards`
export const myWalletVirtualCardDetailUrl = (id: string): string =>
  `${myWalletUrl()}/virtualcards/${id}`
export const myWalletPhysicalCardsUrl = (): string =>
  `${myWalletUrl()}/physicalcards`
export const myWalletTransactionsURL = (): string =>
  `${myWalletUrl()}/transactions`
export const myWalletBudgetsURL = (): string => `${myWalletUrl()}/budgets`
export const myWalletBudgetsPendingURL = (): string =>
  `${myWalletUrl()}/pendingbudgets`

export const managerReviewURL = (): string => '/review'
export const managerReviewTransactionsURL = (): string =>
  `${managerReviewURL()}/transactions`
export const managerReviewReimbursementsURL = (): string =>
  `${managerReviewURL()}/reimbursements`

export const cardsUrl = (): string => '/cards'
export const cardsPhysicalCardsUrl = (): string => `${cardsUrl()}/physicalcards`
export const activityUrl = (): string => '/activity'
export const insightsUrl = (): string => '/insights'
export const streamingAgentUrl = (): string => '/agent'
export const virtualCardDetailUrl = (id: string): string =>
  `${virtualCardsUrl()}/${id}`
export const accountUrl = (id: string): string => `/accounts/${id}`
export const accountOverviewUrl = (id: string): string =>
  `${accountUrl(id)}/overview`
export const accountBudgetsUrl = (id: string): string =>
  `${accountUrl(id)}/budgets`
export const accountVirtualCardsUrl = (id: string): string =>
  `${accountUrl(id)}/virtualcards`
export const accountTransactionsUrl = (id: string): string =>
  `${accountUrl(id)}/transactions`
export const accountHistoryUrl = (id: string): string =>
  `${accountUrl(id)}/history` // TODO: investigate if we can remove this
export const accountSettingsUrl = (id: string): string =>
  `${accountUrl(id)}/settings`
export const accountsUrl = (): string => '/accounts'
export const accountsAccountsUrl = (): string => `${accountsUrl()}/youraccounts`
export const accountsBudgetsUrl = (): string => `${accountsUrl()}/budgets`
export const accountsVirtualCardsUrl = (): string =>
  `${accountsUrl()}/virtualcards`
export const accountsRequestsUrl = (): string => `${accountsUrl()}/requests`
export const budgetsUrl = (): string => `/budgets`
export const budgetsAllBudgetsUrl = (): string => `${budgetsUrl()}/all`
export const budgetsRequestsUrl = (): string => `${budgetsUrl()}/requests`
export const budgetsNeedsApprovalUrl = (): string =>
  `${budgetsUrl()}/needsapproval`
export const budgetUrl = (id: string): string => `${budgetsUrl()}/${id}`
export const budgetOverviewUrl = (id: string): string =>
  `${budgetUrl(id)}/overview`
export const budgetVirtualCardsUrl = (id: string): string =>
  `${budgetUrl(id)}/virtualcards`
export const budgetTransactionsUrl = (id: string): string =>
  `${budgetUrl(id)}/transactions`
export const budgetHistoryUrl = (id: string): string =>
  `${budgetUrl(id)}/history`
export const profileUrl = (): string => '/profile'
export const profileOverviewUrl = (): string => `${profileUrl()}/overview`
export const profileInfoUrl = (): string => `${profileUrl()}/info`
export const profileNotificationsUrl = (): string =>
  `${profileUrl()}/notifications`
export const profileDeleteUrl = (): string => `${profileUrl()}/manage` // TODO: refactor this
export const profileSecurityUrl = (): string => `${profileUrl()}/security`
export const transactionsUrl = (): string => '/transactions'
export const transactionsAllTransactionsUrl = (): string =>
  `${transactionsUrl()}/all`
export const transactionsYourTransactionsUrl = (): string =>
  `${transactionsUrl()}/yours`
export const peopleUrl = (): string => `/people`
export const peopleMembersUrl = (): string => `${peopleUrl()}/members`
export const peopleInvitedToOrgUrl = (): string => `${peopleUrl()}/invited`
export const peopleCancelOrgInviteUrl = (id: string): string =>
  `${peopleInvitedToOrgUrl()}/cancel/${id}`
export const expensesUrl = (): string => `/expenses`
export const expenseReportUrl = (reportId: string): string =>
  `/expensereport/${reportId}`
export const organizationSettingsUrl = (id: string): string =>
  `/organizationSettings/${id}`
export const automationSettingsUrl = (id: string): string =>
  `/organizationSettings/${id}/automation`
export const businessRulesUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/businessrules`
export const organizationInfoUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/organizationinfo`
export const organizationSsoUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/sso`
export const manageSubscriptionUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/managesubscription`
export const expenseCategoriesUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/expensecategories`
export const expenseCategoriesAccountingUrl = (id: string): string =>
  `${expenseCategoriesUrl(id)}/account`
export const expenseCategoriesAdditionalFieldsUrl = (id: string): string =>
  `${expenseCategoriesUrl(id)}/custom`
export const customFieldDetailUrl = (
  orgId: string,
  customFieldId: string,
): string => `${expenseCategoriesAdditionalFieldsUrl(orgId)}/${customFieldId}`
export const automationRulesUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/rules`
export const expenseRequirementsUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/expenserequirements`
export const expenseRequirementsReceiptRulesUrl = (id: string): string =>
  `${expenseRequirementsUrl(id)}/receiptrules`
export const expenseRequirementsAdditionalFieldsUrl = (id: string): string =>
  `${expenseRequirementsUrl(id)}/additionalfields`
export const orgSettingsReimbursementsUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/reimbursements`

export const apiKeysUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/apikeys`
export const apiKeysProfileUrl = (): string => `${profileOverviewUrl()}/apikeys`
export const expenseCategoryLabelsUrl = (
  id: string,
  expenseCategoryId: string,
): string => `${expenseCategoriesUrl(id)}/${expenseCategoryId}`
export const organizationIntegrationsUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/integrations`
export const expenseSettingsUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/expenseSettings`
export const departmentsUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/departments`
export const cardFeedsUrl = (): string => `/cardfeeds`
export const cardFeedDetailsUrl = (id: string): string =>
  `${cardFeedsUrl()}/${id}`
export const createCardFeedUrl = (): string => `${cardFeedsUrl()}/create`
export const departmentDetailsUrl = (
  id: string,
  departmentId: string,
): string => `${departmentsUrl(id)}/${departmentId}`
export const expensesAllReportsUrl = (): string => `${expensesUrl()}/allReports`
export const expensesYourReportsUrl = (): string =>
  `${expensesUrl()}/yourReports`
export const expensesOutOfPocketReportsUrl = (): string =>
  `${expensesUrl()}/outofpocket`

export const submitExpensesUrl = (): string => `${myWalletUrl()}/reimbursements`

export const myWalletReimbursementURL = (reportId: string): string =>
  `${submitExpensesUrl()}/${reportId}`

export const managerReviewReimbursementURL = (reportId: string): string =>
  `${managerReviewReimbursementsURL()}/${reportId}`

export const reimbursementsUrl = (): string =>
  `${expensesOutOfPocketReportsUrl()}/all`

export const expensesExpenseReportsUrl = (): string => `${expensesUrl()}/cycles`
export const orgExpenseReportsHistoricalReportsUrl = (id: string): string =>
  `${expensesExpenseReportsUrl()}/${id}`
export const orgExpenseReportUrl = (
  cycleId: string,
  reportId: string,
): string =>
  `${orgExpenseReportsHistoricalReportsUrl(cycleId)}/report/${reportId}`
export const expensesTransactionsUrl = (): string =>
  `${expensesUrl()}/transactions`
export const expensesNeedsApprovalUrl = (): string =>
  `${expensesUrl()}/transactions/needsapproval`
export const billPayUrl = (): string => `/billpay`
export const billPayAllUrl = (): string => `${billPayUrl()}/all`
export const billPayNeedsApprovalUrl = (): string =>
  `${billPayUrl()}/needsapproval`
export const billPayDetailUrl = (id: string): string => `${billPayUrl()}/${id}`
export const cspStub = (): string => `/csp`
export const downloadsUrl = (): string => `/downloads`
// authed popup
export const deactivateVirtualCardUrl = (id: string): string =>
  `${virtualCardDetailUrl(id)}/deactivate/`
export const screenVirtualCardUrl = (id: string): string =>
  `${virtualCardDetailUrl(id)}/screen/`
export const deactivateBudgetUrl = (id: string): string =>
  `${budgetUrl(id)}/deactivate/`
export const registerAccountUrl = (): string => '/accounts/create'
export const updateProfilePhotoUrl = (): string => '/profile/photo'
export const userScreeningInfoUrl = (): string => '/profile/screening'
export const actionUnavailableUrl = (): string => '/actionunavailable'
export const downloadTransactionsUrl = (): string => '/downloadtransactions'
export const registerOrganizationUrl = (): string => '/orgs/create'
export const manageOrgInviteUrlStub = (): string => `/orgs/invitation`
export const manageOrgInviteUrl = (id: string): string =>
  `${manageOrgInviteUrlStub()}/${id}`
export const removeUserFromOrganizationUrl = (id: string): string =>
  `/orgs/${id}/remove`
export const changePasswordUrl = (): string =>
  `${profileSecurityUrl()}/changepassword`
export const manageTrustedDevicesUrl = (): string =>
  `${profileSecurityUrl()}/devices`
export const createOrgIntegrationUrl = (id: string): string =>
  `${organizationSettingsUrl(id)}/integrations`
export const manageOrgIntegrationUrl = (
  id: string,
  integrationId: string,
): string =>
  `${organizationSettingsUrl(id)}/integrations/${integrationId}/manage`
export const closeVirtualCardUrl = (id: string): string =>
  `${virtualCardDetailUrl(id)}/close`
export const closeBillPayCardUrl = (id: string): string =>
  `${billPayDetailUrl(id)}/close`
export const closeAccountUrl = (id: string): string =>
  `${accountSettingsUrl(id)}/close`
export const setOrgExpenseReportCycleUrl = (id: string): string =>
  `${orgExpenseReportsHistoricalReportsUrl(id)}/update`
export const shareBillPayVirtualCardUrl = (id: string): string =>
  `${virtualCardDetailUrl(id)}/share`
export const deactivateBillPayCardUrl = (id: string): string =>
  `${billPayDetailUrl(id)}/deactivate`
export const upgradeSubscriptionUrl = (): string => '/upgradesubscription'

// authed left
export const helpUrl = (): string => '/help'
export const searchUrl = (): string => '/search'
export const cspUserDetailUrl = (id: string): string =>
  `${cspStub()}/users/${id}`
// authed right flyout
export const createVirtualCardUrl = (): string => `${virtualCardsUrl()}/create`
export const requestVirtualCardUrl = (): string =>
  `${virtualCardsUrl()}/request`
export const updateVirtualCardUrl = (id: string): string =>
  `${virtualCardDetailUrl(id)}/update`
export const createBudgetUrl = (): string => `${budgetsUrl()}/create`
export const requestBudgetUrl = (): string => `${budgetsUrl()}/request`
export const updateBudgetRequestUrl = (id: string): string =>
  `/budgetrequests/${id}/update`
export const updateBudgetUrl = (id: string): string => `${budgetUrl(id)}/update`
export const transactionDetailUrl = (id: string): string =>
  `/transactions/${id}`
export const transactionAttachmentUrl = (
  id: string,
  attachmentId: string,
): string => `/transactions/${id}/${attachmentId}`
export const peopleMembersDetailUrl = (id: string): string =>
  `${peopleMembersUrl()}/${id}`
export const peopleInvitedToOrgDetailUrl = (id: string): string =>
  `${peopleInvitedToOrgUrl()}/${id}`
export const invitePeopleUrl = (): string => `/invite/people`
export const featureFlaggerUrl = (): string => '/featureflagger'
export const addExpenseUrl = (id: string): string =>
  `${expensesUrl()}/addExpense/${id}`
export const updateExpenseUrl = (id: string): string =>
  `${expensesUrl()}/updateExpense/${id}`
export const updateBulkTransactions = (): string =>
  `${expensesTransactionsUrl()}/bulkupdate`
export const createAutomationRuleUrl = (id: string): string =>
  `${automationRulesUrl(id)}/create`
export const updateAutomationRuleUrl = (
  orgId: string,
  ruleId: string,
): string => `${automationRulesUrl(orgId)}/${ruleId}/update`
export const bulkUploadExpenseLabelsUrl = (
  id: string,
  expenseCategoryId: string,
): string => `${expenseCategoryLabelsUrl(id, expenseCategoryId)}/bulkupload`
// TODO: refactor these into separate URLs (i.e. /budgets/needsapproval/:id, /budgets/pending/:id, /budgets/requests/:id)
export const budgetRequestUrl = (id: string): string[] => [
  `${budgetsRequestsUrl()}/${id}`,
  `${myWalletBudgetsPendingURL()}/${id}`,
  `${budgetsNeedsApprovalUrl()}/${id}`,
]
export const createBillPayUrl = (): string => '/billpay/create'
export const updateBillPayUrl = (id: string): string => `/billpay/${id}/update`

export const accountingUrl = (): string => '/accounting'
export const accountingReviewReportsUrl = (): string =>
  `${accountingUrl()}/transactions`

// unauthed
export const signinUrl = (): string => '/signin'
export const verifyEmailUrl = (): string => '/verifyemail'
export const signupUrl = (): string => '/signup'
export const resetPasswordUrl = (): string => '/resetpassword'
export const cspSigninUrl = (): string => `${cspStub()}/signin`
export const onboardingUrl = (): string => '/onboarding'
export const onboardingCardUrl = (): string => '/onboarding/card'
export const orgInviteDecisionUrl = (): string => '/orginvitedecision'
export const ssoCallbackUrl = (): string => '/sso/callback'
// shared authed and unauthed
export const faqUrl = (): string => '/faq'
export const termsUrl = (): string => '/terms'
export const privacyUrl = (): string => '/privacy'
export const supportUrl = (): string => '/support'
export const supportRequestUrl = (): string => '/support-request'
export const gettingStartedGuideUrl = (): string =>
  'https://paywithextend.com/guides/introduction?utm_source=extend&utm_medium=product&utm_campaign=gsg&utm_content=navigation'
// external
export const helpCenterUrl = (): string =>
  'https://support.paywithextend.com/hc/'

// FLAT ARCHITECTURE ROUTES

// AUTHENTICATED
export const PRICING_ROUTE = (cardId: string | undefined = undefined): string =>
  `/pricing/tiers${cardId ? `?cardId=${cardId}` : ''}`
export const MARCOM_PRICING_ROUTE = (): string => '/pricing/marcom'
export const CANCEL_SUBSCRIPTION_ROUTE = (orgId: string): string =>
  `/organizationSettings/${orgId}/cancelsubscription`
/* HYGEN-INJECT-URL */
export const CREATE_CARD_ASTRADA = (): string => '/new-card'
